import React, { useEffect, useRef, useState } from "react";

import HttpManager from "../../../../services/HttpManager";
import { MentorWorkshopSessionDTO, MentorWorkshopSessionsDTO } from "../../../../services/v2/workshops.service";
import S from "./strings";
import { errorText, usePlantel } from "./comun";
import { Chip, diaSemanaFecha, rangoHoras } from "./piezasTaller";
import { PasarLista, marcaDe } from "./asistencia";

/*
	The teacher's workshop days in Asistencias (Módulos Claros, 2026-11-01, approved by Esteban): her days of the last week
	(today first) with «Pasar Lista», the same window the workshop uses. Shows nothing when she has no workshop days.
*/
const TalleresMaestra: React.FC = () => {
	const http = HttpManager.getInstance();
	const { campusId } = usePlantel();
	const [d, setD] = useState<MentorWorkshopSessionsDTO | null>(null);
	const [abierto, setAbierto] = useState<MentorWorkshopSessionDTO | null>(null);
	const [enCurso, setEnCurso] = useState<string[]>([]);
	const [error, setError] = useState<string | null>(null);
	const peticion = useRef<number>(0); // only the answer to the latest mark is painted

	useEffect(() => {
		if (!campusId) return;
		let vigente = true;
		http.workshopsService.mentorSessions(campusId).then((r) => { if (vigente) setD(r.data); }).catch(() => { if (vigente) setD(null); });
		return () => { vigente = false; };
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [campusId]);

	if (!campusId || !d || d.sessions.length === 0) return null;
	const sesion = abierto ? d.sessions.find((x) => x.id === abierto.id) || abierto : null;

	const marcar = (diaId: number, attendeeId: number, vino: boolean) => {
		const clave = diaId + "_" + attendeeId;
		setError(null);
		setEnCurso((x) => [...x, clave]);
		setD((x) => x ? { ...x, sessions: x.sessions.map((s) => s.id !== diaId ? s : { ...s, students: s.students.map((a) => a.attendeeId === attendeeId ? { ...a, attended: vino, marked: true } : a) }) } : x);
		const n = ++peticion.current;
		http.workshopsService.mentorAttendance(campusId, diaId, attendeeId, vino)
			.then((r) => { if (n === peticion.current) setD(r.data); })
			.catch((e) => { setError(errorText(e)); http.workshopsService.mentorSessions(campusId).then((r) => setD(r.data)).catch(() => { /* keeps what is painted */ }); })
			.finally(() => setEnCurso((x) => x.filter((y) => y !== clave)));
	};

	return (
		<div className="wtlMaestra">
			<h5 style={{ margin: "4px 0 8px 0" }}>{S.misTalleres}</h5>
			{d.sessions.map((x) => {
				const vinieron = x.students.filter((a) => a.attended).length;
				const pendientes = x.students.filter((a) => !a.marked).length;
				return (
					<div key={x.id} className="wtlTarjeta" role="button" tabIndex={0} onClick={() => setAbierto(x)} onKeyDown={(e) => { if (e.key === "Enter") setAbierto(x); }}>
						<div style={{ minWidth: 0 }}>
							<b>{x.workshopName}</b>
							<div className="wtlSub">{[x.date === d.today ? S.hoy : diaSemanaFecha(x.date), rangoHoras(x.startTime, x.endTime), x.classroomName].filter(Boolean).join(", ")}</div>
						</div>
						<span style={{ display: "inline-flex", gap: 6, alignItems: "center", flexShrink: 0 }}>
							{pendientes > 0 && x.students.length ? <Chip tono="oro">{S.vino} {S.presentes(vinieron, x.students.length)}</Chip> : <Chip>{S.vino} {S.presentes(vinieron, x.students.length)}</Chip>}
							<button type="button" className="btn btn-primary btn-sm rounded-pill" onClick={(e) => { e.stopPropagation(); setAbierto(x); }}>{S.pasarLista}</button>
						</span>
					</div>
				);
			})}
			{sesion ? (
				<PasarLista titulo={<>{S.pasarLista}<span className="wtlSub" style={{ fontSize: 14 }}>{sesion.workshopName}</span></>}
					dias={[{ id: sesion.id, date: sesion.date, startTime: sesion.startTime, endTime: sesion.endTime }]} diaElegido={sesion.id}
					enCurso={enCurso} error={error} onMarcar={marcar} onClose={() => { setAbierto(null); setError(null); }}
					alumnas={() => sesion.students.map((a) => ({ attendeeId: a.attendeeId, name: a.name, code: a.identityCode, marca: marcaDe(a.attended, a.marked) }))} />
			) : null}
		</div>
	);
};

export default TalleresMaestra;
